import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@lockton-apps/material';
import { UiModule } from '@lockton-apps/shared/ui/lui';

import { DynamicFormCalcTableCellModule } from '../dynamic-form-calc-table-cell/dynamic-form-card.module';
import { DynamicFormCellModule } from '../dynamic-form-cell/dynamic-form-cell.module';
import { InputFieldTypeModule } from '../input-field-type/input-field-type.module';
import { FieldMetaPipe } from '../pipes/field-meta/field-meta.pipe';
import { FieldOrderPipe } from '../pipes/field-order/field-order.pipe';
import { DynamicFormCardComponent } from './dynamic-form-card.component';
import { DynamicFormCardTotalPipe } from './pipes/dynamic-form-card-total.pipe';

@NgModule({
  declarations: [DynamicFormCardComponent, DynamicFormCardTotalPipe],
  imports: [
    CommonModule,
    InputFieldTypeModule,
    MaterialModule,
    UiModule,
    FieldOrderPipe,
    FieldMetaPipe,
    DynamicFormCellModule,
    DynamicFormCalcTableCellModule,
  ],
  exports: [DynamicFormCardComponent],
})
export class DynamicFormCardModule {}
